export default "<div id=\"kaltura_player_1565720477\" style=\"\r\n          width: 100vw;\r\n          height: 100vh;\r\n        \">\r\n</div>";